<script setup>
import ListingTable from '@/components/dashboard/ListingTable.vue'

definePage({
  meta: {
    layout: 'default',
    requiresAuth: true,
    roles: ['admin'],
  },
})
</script>

<template>
  <VContainer class="py-4">
    <ListingTable
      title="All listings"
      endpoint="/api/admin/listings"
      :auto-apply-on-mount="true"
    />
  </VContainer>
</template>
